import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  useSettlementsQuery,
  useStreetsQuery,
} from "@services/adresses/queries";

export const useHouseName = (
  municipalityId: number | undefined,
  settlementId: number | undefined,
  streetId: number | undefined,
  houseNumber: string | undefined,
  apartmentNumber: string | undefined,
): string => {
  const { t } = useTranslation();

  const { data: settlements } = useSettlementsQuery(
    municipalityId ?? 0,
    !!municipalityId,
  );

  const { data: streets } = useStreetsQuery(
    municipalityId ?? 0,
    settlementId ?? 0,
    !!settlementId,
  );

  return useMemo(() => {
    const selectedSettlement = settlements?.find(
      (s) => s.settlementId === settlementId,
    );
    const selectedStreet = streets?.find((s) => s.streetId === streetId);

    if (selectedSettlement) {
      if (selectedStreet) {
        if (houseNumber) {
          if (apartmentNumber) {
            return `${selectedStreet.name} ${houseNumber}-${apartmentNumber}, ${selectedSettlement.name}`;
          }
          return `${selectedStreet.name} ${houseNumber}, ${selectedSettlement.name}`;
        }
        return `${selectedStreet.name}, ${selectedSettlement.name}`;
      }
      return selectedSettlement.name;
    }

    return t("common.defaultAddress");
  }, [
    streetId,
    settlementId,
    houseNumber,
    apartmentNumber,
    settlements,
    streets,
    t,
  ]);
};
